import React, { PropsWithChildren } from 'react';

import * as Styled from './styled';

const PageFooter: React.FC<PropsWithChildren<Styled.FooterProps>> = (props) => <Styled.Footer {...props}>{props.children}</Styled.Footer>;
export default PageFooter;
